var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._g(_vm._b({
    staticClass: "preview",
    attrs: {
      "modal": false,
      "before-close": _vm.handleBeforeClose,
      "title": "预览"
    }
  }, 'el-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "bg-img"
  }, [(_vm.isVideo(_vm.selection)) ? _c('video', {
    ref: "video",
    staticClass: "video",
    attrs: {
      "src": _vm.selection.url,
      "alt": _vm.selection.name,
      "controls": ""
    }
  }) : _c('img', {
    staticClass: "mosaic-bg",
    attrs: {
      "src": _vm.selection.url,
      "alt": _vm.selection.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleToEdit
    }
  }, [_vm._v("剪 切")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")])], 1), _vm._v(" "), (_vm.list.length) ? _c('ul', {
    staticClass: "thumbnail-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      key: item.url,
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.handleSwitch(item)
        }
      }
    }, [(_vm.isVideo(item)) ? _c('video', {
      staticClass: "mosaic-bg",
      attrs: {
        "src": item.url,
        "alt": item.name
      }
    }) : _c('img', {
      staticClass: "mosaic-bg",
      attrs: {
        "src": item.url,
        "alt": item.name
      }
    })])
  })) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d60a365", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d60a365","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QnUpload-1.0.0/preview/index.vue
// module id = wK7E
// module chunks = 212